<template>
  <div>
    <h3>All products</h3>
    <ProductList
      v-model="page"
      class="product-list-section"
      :productChunks="filteredProductChunks || productChunks"
      :language="language"
      :isLoading="isFetching"
      @page-change="handlePageChange"
      @search="handleSearch"
    />
  </div>
</template>

<script>
import ProductList from "@/components/Products/ProductList.vue";
export default {
  components: { ProductList },
  name: "AllProductsView",
  data() {
    return {
      searchString: "",
      page: 0,
    };
  },
  methods: {
    async handlePageChange(e) {
      if (
        !this.filteredProductChunks &&
        !this.productChunks?.[e.current]?.loaded
      ) {
        const productList = await this.$store.dispatch("fetchProductChunks", {
          ids: this.productChunks[e.current].ids,
        });

        this.$store.commit("setProducts", {
          productList,
          chunkIndex: e.current,
        });

        return;
      }

      if (
        this.filteredProductChunks &&
        !this.filteredProductChunks?.[e.current].loaded
      ) {
        this.$store.dispatch("filterProducts", {
          searchString: this.searchString,
          language: this.language || "en",
          chunkIndexes: [e.current],
        });
      }
    },
    async handleSearch(e) {
      this.searchString = e;
      const currentRoute = this.$route;

      const searchRoute = {
        name: "allProducts",
        ...(e.length
          ? {
              query: {
                ...(this.$route.query || {}),
                search: e,
              },
            }
          : {}),
      };

      const resolvedRoute = this.$router.resolve(searchRoute);

      if (!currentRoute.query.search) {
        this.$router.push(searchRoute);
      } else if (currentRoute.fullPath !== resolvedRoute.route.fullPath) {
        this.$router.replace(searchRoute);
      }

      await this.$store.dispatch("filterProducts", {
        searchString: this.$route.query?.search || this.searchString,
        language: this.language || "en",
      });

      this.page = 0;
    },
    handleRouteChange() {},
    async initProducts() {
      if (this.$route.query?.search) {
        await this.handleSearch(this.$route.query.search);
      } else if (!this.productChunks) {
        await this.$store.dispatch("fetchProducts");
      }
    },
  },
  computed: {
    filteredProductChunks() {
      return this.$store.getters.filteredProductChunks;
    },
    productChunks() {
      return this.$store.getters.productChunks;
    },
    language() {
      return this.$route.query.lang;
    },
    isFetching() {
      return this.$store.getters.isFetching;
    },
  },
  watch: {
    page() {
      // const currentRoute = this.$route;
      // const pageRoute = {
      //   name: "products",
      //   query: {
      //     ...this.$route.query,
      //     page: this.page + 1,
      //   },
      // };
      // const resolvedRoute = this.$router.resolve(pageRoute);
      // if (currentRoute.fullPath !== resolvedRoute.route.fullPath) {
      //   this.$router.push(pageRoute);
      // }
    },
    "$route.query.page"() {
      // if (this.page !== this.$route.query.page - 1) {
      //   this.page = this.$route.query.page - 1;
      // }
    },
  },
  created() {
    this.initProducts().then(() => {
      if (this.$route.query?.page) {
        this.page = +this.$route.query.page - 1;
        this.handlePageChange({ current: this.page });
      }
    });
  },
};
</script>

<style></style>
